import React, {useState} from "react";
import ServiceItem from "../components/ServiceItem";


const ExpandableText = ({ title, text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const shortText = text.slice(0, 150);

  return (
    <div className="service-intro-column">
      <h1>{title}</h1>
      <p>
        {isExpanded ? text : `${shortText}...`}
        <span className="see-more-btn" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? "Show less" : "See more"}
        </span>
      </p>
    </div>
  )
}

function Service() {
    const services = [
        {
            title: 'Design Consultation',
            description:
        'Personalised interior design guidance tailored to your lifestyle, covering space planning, concept development, colour coordination, and material selection.',
        },

        {
            title: '3D Mockups',
            description:
              'Detailed 3D visualisations that allow you to preview your space clearly, ensuring confidence and clarity before construction begins.',
          },
          {
            title: 'Budget Allocation',
            description:
              'Strategic planning to optimise your renovation budget, delivering the best possible value without compromising on design or quality.',
          },
          {
            title: 'Full Renovation Supervision',
            description:
              'Dedicated site supervision to ensure workmanship quality, timeline control, and accurate execution of the approved design.',
          },
          {
            title: 'Design & Build',
            description:
              'A seamless approach where design and construction are managed under one roof, reducing coordination gaps and ensuring cohesive results.',
          },
          {
            title: 'Cabinetry & Wood Works',
            description:
              'Custom woodwork carfted by our in-house team, offering consistency, flexibility, and refined detailing across projects.',
          },
          {
            title: 'Spray Painting / \nVeneering / \nLacquering / \nVanishing',
            description:
              'By aligning your design vision with carefully chosen finishes, our spray painting, veneering, lacquering, and vanishing deliver elegant surfaces with lasting quality.',
          },

          {
            title: 'Other Services',
            description:
              'We also manage variety of scopes including, Dry/Wet wall, Wiring works, Ceiling works, Floor finished, Wall finished.',
          },
    ];

    const whyChooseUs = [
      {title: "One team. One Vision", desc: "Design and build managed together to ensure consistency, efficiency, and accountability throughout the project."},
      {title: "In-House Craftsmanship", desc: "Our factory-made cabinetry and woodworking allow us to maintain strict quality control and deliver refined finishes."},
      {title :"Thoughtful Design, Practical Execution", desc: "Every design is created with buildability in mind, ensuring what is designed can be executed smoothly on site."},
      {title :"Clear Process, Minimal Stress", desc :"From planning to handover, we manage coordination, timelines, and supervision so you can enjoy the journey with confidence."},
      {title :"Built to Last", desc: "We prioritise durable materials, skilled workmanship, and long-term functionality in every soace we create."}
    ]

    return (
        <section className="service">
            <div className="container">
              <h1 className="section-title-2">Who We Are?</h1>
              <p className="service-main-intro">At Jian Mavrik Design, we provide a complete design and build solution, managing every stage from concept to completion. With in-house cabinetry, thoughtful design, and dedicated project supervision, we ensure a seamless renovation experience and spaces crafted with lasting quality.</p>
                {/*<div className="service-intro-2">
                    <ExpandableText 
                        title="Customise Cabinetry" 
                        text="We offer bespoke cabinetry crafted directly in our factory, allowing us to manage your project seamlessly from concept to completion. Our end-to-end service covers design development, material selection, specialised in-house woodworking, and premium finishing—including spray paint finishes. With a strong emphasis on craftsmanship and durability, we deliver timeless, high-quality cabinetry tailored to enhance every space in your home." 
                    />
                    <ExpandableText 
                        title="Full Renovation" 
                        text="From initial design consultation to final handover, we provide a fully integrated renovation service for your entire space. Our scope includes design consultation, 3D visualisation, space planning, M&E and lighting design, colour and material coordination, and furniture specification. By overseeing every detail with precision and care, we ensure a seamless renovation experience and bring your ideal living environment to life." 
                    />
                </div>*/}

                    <div className="our-strengths-section">
                      <h2 className="strengths-header">Our Strengths</h2>
                      <p className="strengths-intro">
                      {/*<span className="OUR-STRENGTHS">OUR STRENGTHS</span>*/}Our core strength lies in our in-house factory production, allows us to maintain full control over the manufacturing process. This provides several key advantages:
                      </p>
  
                      <div className="newspaper-columns">
                        <div className="strength-column">
                          <h3>Cost Efficiency</h3>
                          <p>Factory-direct production eliminates unnecessary middle contractor mark-ups.</p>
      
                          <h3>Quality Control</h3>
                          <p>In-house monitoring by our own team ensures superior workmanship, quality and accuracy.</p>

                          <h3>Better Coordination</h3>
                          <p>Integrated design, production and installation teams significantly reduce project errors.</p>
                        </div>
    
                        <div className="strength-column">
                          

                          <h3>Consistency in Delivery</h3>
                          <p>Our integrated workflow reduces delays for reliable project scheduling.</p>
      
                          <h3>Established Experience</h3>
                          <p>Proven industry experience backed by our own dedicated production facility.</p>
                        </div>
                      </div>
                    

                      


                    </div>



                <h2>Our Services</h2>
                  <div className="service-content">
                  
                    {services.map((service, index) => (
                        <ServiceItem
                        key={index}
                        title={service.title}
                        description={service.description}
                        />
                    ))}
                </div>

                

                <div className="why-choose-section">
                  <h2 className="section-title-3">Why Choose Us</h2>
                  <div className="why-choose-grid">
                    {whyChooseUs.map((item, index)=>(
                      <div key = {index} className="why-choose-item">
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                        </div>
                    ))}
                  </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default Service;